export const STATUSES = Object.freeze({
  CREATING: 'Creating',
  READY_TO_GENERATE: 'Ready to Generate',
  COMPLETED: 'Completed',
  GENERATING: 'Generating',
  FAILED: 'Failed',
  NO_DATA: 'No Data',
});
